import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Paper, Typography } from "@mui/material";

export const LogoutLandingPage = () => {
  const auth0 = useAuth0();

  return (
    <Paper sx={{ display: 'flex', flexDirection: 'column', gap: 5, margin: 10, padding: 5 }}>
      <Typography>You are logged out. Please note that this may happen automatically if you stay logged in for a long time.</Typography>
      <Box>
        <Button variant="contained" onClick={() => {
          auth0.loginWithRedirect().catch((e) => console.error('error logging in: ', e))
        }}>{'Login'}
        </Button>
      </Box>
    </Paper>
  )
}